import { useNavigate, useParams, Link } from "react-router-dom";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import SteamLoginButton from "@/components/SteamLoginButton";

export default function NewTopicPage() {
  const { slug } = useParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const { data: cats = [] } = useQuery({
    queryKey: ["forum-categories"],
    queryFn: () => api.get("/forum/categories").then((r) => r.data),
  });
  const cat = cats.find((c) => c.slug === slug);

  if (!user) {
    return (
      <div className="max-w-2xl mx-auto py-16 px-4">
        <Card><CardContent className="p-8 text-center">
          <p className="mb-3">Connectez-vous avec Steam pour créer un sujet.</p>
          <SteamLoginButton />
        </CardContent></Card>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (title.trim().length < 3 || content.trim().length < 3) return;
    setSubmitting(true);
    try {
      const { data } = await api.post("/forum/topics", { category_slug: slug, title, content });
      toast.success("Sujet créé");
      nav(`/forum/t/${data.id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur lors de la création");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-sm text-muted-foreground mb-2">
        <Link to={`/forum/c/${slug}`} className="hover:text-primary">← Retour</Link>
      </div>
      <h1 className="font-display text-3xl uppercase tracking-tight mb-2">Nouveau sujet</h1>
      <p className="text-sm text-muted-foreground mb-6">Dans : <span className="text-primary">{cat?.name || slug}</span> {cat?.visibility === "private_to_author" && "(sujet privé : visible par vous et le staff)"}</p>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-sm font-medium">Titre</label>
          <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Un titre clair et descriptif" maxLength={200} required data-testid="new-topic-title" />
        </div>
        <div>
          <label className="text-sm font-medium">Message</label>
          <Textarea value={content} onChange={(e) => setContent(e.target.value)} rows={10} placeholder="Écrivez votre message..." required data-testid="new-topic-content" />
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" onClick={() => nav(-1)}>Annuler</Button>
          <Button type="submit" disabled={submitting} data-testid="submit-topic-button">{submitting ? "Publication..." : "Publier le sujet"}</Button>
        </div>
      </form>
    </div>
  );
}
